import {
  AgentEffectCommands,
  IntrigueCardProps,
  intrigueCardsDefRepository,
  ResourceType,
  TurnPhase,
} from "~/business";

export const initIntrigueCards = () => {
  const {
    combatPoint,
    or,
    and,
    spice,
    hasAnyAlliance,
    cause,
    payResource,
    canRetreat,
    influencePoints,
    victoryPoint,
    emperorUp,
    guildUp,
    fremenUp,
    draw,
    garnison,
    beneGesseritUp,
    water,
    solaris,
    shuffleDiscardInDeck,
    hasSiege,
    mentat,
    canPassTurn,
    recallAgent,
    chooseLooseConflictTroops,
    replaceOpponentConflictTroop,
    ignoreAgentIcons,
    ignoreOccupiedAgentSlots,
    chooseFactionChange,
    causeRaw,
    drawOrTrashTopCard,
    canBuyOnDeck,
    freeCard,
    hasMoreTSMFThanOpponents,
    hasNCardTSMF,
    hasFactionsLevel,
    discardCard,
    trashCard,
    freighter,
    dreadnought,
    acquireTechTile,
    hasNTechTile,
    factionUpOnSlotWithAgent,
    looseTroop,
    hasResource,
    canDeployToConflictTroop,
    opponentsRetreatDreadnought,
    canDeployToConflictUnit,
    hasDeployedNUnits,
    grandConspiracy,
    onWin,
  } = AgentEffectCommands;

  const { CombatEnd, CombatStart, EndGame, Play } = TurnPhase;

  const baseIntrigueCardDefs: IntrigueCardProps[] = [
    {
      name: "Corner the Market",
      phaseEffects: [
        {
          phase: EndGame,
          effects: [
            and([
              cause(hasNCardTSMF(2)).effect(victoryPoint(1)),
              cause(hasMoreTSMFThanOpponents).effect(victoryPoint(1)),
            ]),
          ],
        },
      ],
    },
    {
      name: "Plans Within Plans",
      phaseEffects: [
        {
          effects: [
            cause(hasFactionsLevel({ factionCount: 3, minLevel: 3 })).effect(
              victoryPoint(1)
            ),
            cause(hasFactionsLevel({ minLevel: 3 })).effect(victoryPoint(1)),
          ],
          phase: EndGame,
        },
      ],
    },
    {
      name: "Tiebreaker",
      phaseEffects: [
        {
          phase: CombatStart,
          effects: [combatPoint(2)],
        },
        {
          phase: EndGame,
          effects: [spice(10)],
        },
      ],
    },
    {
      name: "Ambush",
      instanceCount: 2,
      phaseEffects: [
        {
          effects: [combatPoint(4)],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "Allied Armada",
      phaseEffects: [
        {
          effects: [
            cause(
              and([
                hasAnyAlliance,
                payResource({
                  amount: 2,
                  type: ResourceType.Spice,
                }),
              ])
            ).effect(combatPoint(7)),
          ],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "Demand Respect",
      phaseEffects: [
        {
          effects: [
            or([
              chooseFactionChange(1),
              causeRaw(
                payResource({ amount: 2, type: ResourceType.Spice })
              ).effect(chooseFactionChange(2)),
            ]),
          ],
          phase: CombatEnd,
        },
      ],
    },
    {
      name: "Master Tactician",
      instanceCount: 3,
      phaseEffects: [
        {
          effects: [or([combatPoint(3), canRetreat(3)])],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "Private Army",
      instanceCount: 2,
      phaseEffects: [
        {
          effects: [
            cause(payResource({ amount: 2, type: ResourceType.Spice })).effect(
              combatPoint(5)
            ),
          ],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "Staged Incident",
      phaseEffects: [
        {
          effects: [
            cause(chooseLooseConflictTroops(3)).effect(victoryPoint(1)),
          ],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "To The Victor",
      phaseEffects: [
        {
          effects: [spice(3)],
          phase: CombatEnd,
        },
      ],
    },
    {
      name: "Bribery",
      phaseEffects: [
        {
          effects: [
            cause(
              payResource({ amount: 2, type: ResourceType.Solaris })
            ).effect(influencePoints(1)),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Bindu Suspension",
      phaseEffects: [
        {
          effects: [draw, canPassTurn],
          phase: Play,
        },
      ],
    },
    {
      name: "Bypass Protocol",
      phaseEffects: [
        {
          effects: [
            or([
              freeCard({ cardMaxCost: 3 }),
              causeRaw(
                payResource({ amount: 2, type: ResourceType.Spice })
              ).effect(freeCard({ cardMaxCost: 5, onTop: true })),
            ]),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Calculated Hire",
      phaseEffects: [
        {
          effects: [
            cause(payResource({ amount: 1, type: ResourceType.Spice })).effect(
              mentat
            ),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Charisma",
      phaseEffects: [
        {
          effects: [influencePoints(2)],
          phase: Play,
        },
      ],
    },
    {
      name: "CHOAM Shares",
      phaseEffects: [
        {
          effects: [
            cause(
              payResource({ amount: 7, type: ResourceType.Solaris })
            ).effect(victoryPoint(1)),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Councilor's Dispensation",
      phaseEffects: [
        {
          effects: [cause(hasSiege).effect(spice(2))],
          phase: Play,
        },
      ],
    },
    {
      name: "Dispatch an Envoy",
      instanceCount: 2,
      phaseEffects: [
        {
          effects: [ignoreAgentIcons],
          phase: Play,
        },
      ],
    },
    {
      name: "Double Cross",
      phaseEffects: [
        {
          effects: [
            cause(
              payResource({ amount: 1, type: ResourceType.Solaris })
            ).effect(replaceOpponentConflictTroop),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Favored Subject",
      phaseEffects: [
        {
          effects: [emperorUp],
          phase: Play,
        },
      ],
    },
    {
      name: "Guild Authorization",
      phaseEffects: [
        {
          effects: [guildUp],
          phase: Play,
        },
      ],
    },
    {
      name: "Infiltrate",
      phaseEffects: [
        {
          effects: [ignoreOccupiedAgentSlots],
          phase: Play,
        },
      ],
    },
    {
      name: "Know Their Ways",
      phaseEffects: [
        {
          effects: [fremenUp],
          phase: Play,
        },
      ],
    },
    {
      name: "Poison Snooper",
      instanceCount: 2,
      phaseEffects: [
        {
          effects: [drawOrTrashTopCard],
          phase: Play,
        },
      ],
    },
    {
      name: "Rapid Mobilization",
      phaseEffects: [
        {
          effects: [canDeployToConflictTroop(20)],
          phase: Play,
        },
      ],
    },
    {
      name: "Recruitment Mission",
      phaseEffects: [
        {
          effects: [influencePoints(1), canBuyOnDeck],
          phase: Play,
        },
      ],
    },
    {
      name: "Refocus",
      phaseEffects: [
        {
          effects: [shuffleDiscardInDeck, draw],
          phase: Play,
        },
      ],
    },
    {
      name: "Reinforcements",
      phaseEffects: [
        {
          effects: [
            cause(
              payResource({ amount: 3, type: ResourceType.Solaris })
            ).effect(and([garnison(3), canDeployToConflictTroop(3)])),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Secret of the Sisterhood",
      phaseEffects: [
        {
          effects: [beneGesseritUp],
          phase: Play,
        },
      ],
    },
    {
      name: "The Sleeper Must Awaken",
      phaseEffects: [
        {
          effects: [
            cause(payResource({ amount: 4, type: ResourceType.Spice })).effect(
              victoryPoint(1)
            ),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Urgent Mission",
      phaseEffects: [
        {
          effects: [recallAgent],
          phase: Play,
        },
      ],
    },
    {
      name: "Water of Life",
      phaseEffects: [
        {
          effects: [
            cause(
              and([
                payResource({ amount: 1, type: ResourceType.Water }),
                payResource({ amount: 1, type: ResourceType.Spice }),
              ])
            ).effect(and([draw, draw, draw])),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Water Peddlers Union",
      phaseEffects: [
        {
          effects: [water(1)],
          phase: Play,
        },
      ],
    },
    {
      name: "Windfall",
      phaseEffects: [
        {
          effects: [solaris(2)],
          phase: Play,
        },
      ],
    },
  ];

  const ixIntrigueCards: IntrigueCardProps[] = [
    {
      name: "Blackmail",
      phaseEffects: [
        {
          effects: [cause(chooseFactionChange(-1)).effect(combatPoint(5))],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "Cannon Turrets",
      phaseEffects: [
        {
          effects: [combatPoint(2), opponentsRetreatDreadnought],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "Strategic Push",
      phaseEffects: [
        {
          effects: [combatPoint(2), onWin(solaris(2))],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "Second Wave",
      phaseEffects: [
        {
          effects: [combatPoint(2), canDeployToConflictUnit(2)],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "War Chest",
      phaseEffects: [
        {
          effects: [
            cause(
              payResource({ amount: 2, type: ResourceType.Solaris })
            ).effect(combatPoint(4)),
          ],
          phase: CombatStart,
        },
        {
          phase: EndGame,
          effects: [
            cause(
              hasResource({ amount: 10, type: ResourceType.Solaris })
            ).effect(victoryPoint(1)),
          ],
        },
      ],
    },
    {
      name: "Finesse",
      phaseEffects: [
        {
          effects: [combatPoint(2)],
          phase: CombatStart,
        },
        {
          effects: [
            cause(chooseFactionChange(-1)).effect(chooseFactionChange(1)),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Advanced Weaponry",
      phaseEffects: [
        {
          effects: [
            cause(
              payResource({ amount: 3, type: ResourceType.Solaris })
            ).effect(dreadnought),
          ],
          phase: Play,
        },
        {
          effects: [cause(hasNTechTile(3)).effect(combatPoint(4))],
          phase: CombatStart,
        },
      ],
    },
    {
      name: "Grand Conspiracy",
      phaseEffects: [
        {
          effects: [grandConspiracy],
          phase: EndGame,
        },
      ],
    },
    {
      name: "Strongarm",
      phaseEffects: [
        {
          effects: [cause(looseTroop(1)).effect(factionUpOnSlotWithAgent)],
          phase: Play,
        },
      ],
    },
    {
      name: "Ixian Probe",
      phaseEffects: [
        {
          effects: [
            cause(and([discardCard, discardCard])).effect(and([draw, draw])),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Cull",
      phaseEffects: [
        {
          effects: [
            cause(
              payResource({ amount: 1, type: ResourceType.Solaris })
            ).effect(trashCard),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Secret Forces",
      phaseEffects: [
        {
          effects: [cause(hasSiege).effect(garnison(2))],
          phase: Play,
        },
      ],
    },
    {
      name: "Quid Pro Quo",
      phaseEffects: [
        {
          effects: [
            cause(payResource({ amount: 2, type: ResourceType.Spice })).effect(
              factionUpOnSlotWithAgent
            ),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Glimpse the Path",
      phaseEffects: [
        {
          effects: [
            cause(payResource({ amount: 1, type: ResourceType.Spice })).effect(
              and([water(1), draw])
            ),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Diversion",
      phaseEffects: [
        {
          effects: [cause(hasDeployedNUnits(4)).effect(freighter)],
          phase: Play,
        },
      ],
    },
    {
      name: "Expedite",
      phaseEffects: [
        {
          effects: [
            cause(payResource({ amount: 1, type: ResourceType.Spice })).effect(
              freighter
            ),
          ],
          phase: Play,
        },
      ],
    },
    {
      name: "Machine Culture",
      phaseEffects: [
        {
          effects: [acquireTechTile({})],
          phase: Play,
        },
        {
          phase: EndGame,
          effects: [cause(hasNTechTile(3)).effect(victoryPoint(1))],
        },
      ],
    },
  ];

  intrigueCardsDefRepository.addAll(
    baseIntrigueCardDefs.map((cardDef) => ({
      ...cardDef,
      id: cardDef.name,
    }))
  );
  intrigueCardsDefRepository.addAll(
    ixIntrigueCards.map((cardDef) => ({
      ...cardDef,
      id: cardDef.name,
      extension: "Ix",
    }))
  );
  console.debug("init intrigue cards");
};
